import React, { useState } from 'react'
import { Outlet } from 'react-router-dom'
import HeaderAdmin from './section/HeaderAdmin/HeaderAdmin'
import FooterAdmin from './section/FooterAdmin/FooterAdmin'
import Sidebarr from './section/SideBar/Sidebarr'
import Breadcrumbs from './section/Breadcrumbs/Breadcrumbs'
import './Dashburd.css'

const Dashburd = () => {
  const [mobileOpen, setMobileOpen] = useState(false)

  return (
    <div className="hd-admin-shell">
      <HeaderAdmin onToggleSidebar={() => setMobileOpen((open) => !open)} />
      <div className="hd-admin-body">
        <Sidebarr mobileOpen={mobileOpen} onCloseMobile={() => setMobileOpen(false)} />
        <div className="hd-admin-right">
          <Breadcrumbs />
          <main className="hd-admin-content">
            <Outlet />
          </main>
        </div>
      </div>
      <FooterAdmin />
    </div>
  )
}

export default Dashburd
